import { chromaTokens, chromaSailTokens } from './Chroma';
import { twilightTokens } from './Twilight';
import { cottonCandyTokens } from './CottonCandy';
import { lemonlimeTokens } from './LemonLime';
import { pomegranateTokens } from './Pomegranate';
import { sunburstTokens } from './Sunburst';
import { wintergreenTokens } from './Wintergreen';
export const flavors = {
    chroma: chromaTokens,
    chromaSail: chromaSailTokens,
    twilight: twilightTokens,
    cottonCandy: cottonCandyTokens,
    lemonLime: lemonlimeTokens,
    pomegranate: pomegranateTokens,
    sunburst: sunburstTokens,
    wintergreen: wintergreenTokens
};

//# sourceMappingURL=index.js.map